(function (angular) {
	'use strict';

	angular.module('twoFactorAuthModule', [
		'coreModule',
		'formValidationModule',
		'ui.mask'
	])
	.value('globalConfig', globalConfig);
})(window.angular);